<template>
  <div class="recruitment_dynamic_container" v-show="list.length > 0">
    <div class="title">
      校招宣讲
    </div>
    <div class="content">
      <a class="item" v-for="item in showList.slice(0, 10)" :key="item.img" target="_blank" :href="!item.status ? `/videos/${item.token || ''}.html` : `/live/${item.token}`">
        <div class="tips" v-show="!!item.status && item.status != 2">
          <div :class="['tips-label',item.status !== 1 ? 'stoped' : '']"><span>{{item.status == 1 ? '直播' : '直播结束'}}</span></div>
          <div class="tips-time">{{(item.status == 1 ? item.appointment_time : item.end_at) | formateTime}}</div>
        </div>
        <div class="directing" v-show="!!item.status && item.status == 2">
          <i class="iconfont iconzhibozhong"></i>
          <span>正在直播中...</span>
        </div>
        <div class="top">
          <img :src="item.img"/>
          <div class="info">
            <div class="hot">
              <i class="iconfont iconredu"></i>
              <div>{{item.view_count}}</div>
            </div>

            <div class="jobs-count">
              <i class="iconfont iconzhiwei" style="margin-left: 2px;"></i>
              <div>{{item.company_info.jobs_count}}个在招</div>
            </div>
          </div>
        </div>

        <div class="bottom">
          <img :src="item.company_info.company_logo" class="left"/>
          <div class="right">
            <div class="company-name">{{item.title}}</div>
            <div class="desc">{{item.desc}}</div>
          </div>
        </div>

      </a>
    </div>
  </div>
</template>

<script>
	import api from '@/api';
  const moment = require('moment')
	export default {
		data() {
			return {
				list: [],
        directList: []
			}
		},
    computed:{
      showList(){
        return this.directList.concat(this.list)
      }
    },
    filters:{
      formateTime(val){
        return moment(val).format("MM-DD HH:mm")
      }
    },
		created() {
			api.jobs.getVideo().then(res => this.list = res.data.pages)
      api.jobs.getLiveList().then(res =>{
        if(res.code === 1000) {
          this.directList = res.data.lives
          this.directList.forEach(item => {
            let date = new Date().valueOf()
            let startTime = new Date(item.start_at).valueOf()
            let endTime = new Date(item.end_at).valueOf()
            // 未开始
            if(startTime > date){
              item.status = 1
            } 
            // 正在直播中
            else if(startTime <= date && date <= endTime){
              item.status = 2
            }
            // 已经结束
            else{
              item.status = 3
            }
          })
        }
      })
		},
    methods:{
      toDeail(item) {
        if(!item.status) {
          window.open(`/videos/${item.token}.html`,"_blank")
        } else {
          window.open(`/live/${item.token}`,"_blank")
        }
      }
    }
	}
</script>

<style lang="scss" scoped>
  .recruitment_dynamic_container {
    width: 100%;
    margin: 27px 0;
  }
  .title {
    margin-bottom: 24px;
    color: #404040;
    font-size: 22px;
    font-weight: bold;
    height: 30px;
    position: relative;
    line-height: 30px;
    a {
      position: absolute;
      right: 0;
      cursor: pointer;

      font-size: 14px;
      color: #606060;
      &:hover{
        color: #9c9c9c;
        &>i{
          color: #9c9c9c;
        }
      }
      &>i{
        position: relative;
        color: #959595;
        top: 1px;
      }
    }
  }
  .content {
    display: flex;
    flex-wrap: wrap;
    // justify-content: space-between;
    gap: 16px;
    .item {  
      border-radius: 6px;
      // margin-bottom: 16px;
      background-color: #ffffff;
      color: #404040;
      /*height: 168px;*/
      width: 226px;
      position: relative;
      // margin-right: 12px;
      &:hover{
        box-shadow: 0px 2px 28px 0px rgba(10,44,156, .1);

        // p {
        //     color: #FF6644;
        // }
      }
      .directing{
        width: 108px;
        height: 24px;
        background: #4183FF;
        border-radius: 4px;
        color: #fff;
        font-size: 12px;
        font-weight: 600;
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        top: 8px;
        right: 8px;
        z-index: 1;
        &>span{
          margin-left: 3px;
        }
      }
      .tips{
        padding: 4px;
        background-color: rgba(0, 0, 0, 0.6);
        display: flex;
        align-items: center;
        color: #fff;
        font-weight: 600;
        position: absolute;
        top: 8px;
        right: 8px;
        border-radius: 4px;
        z-index: 1;
        .stoped{
          width: 48px !important;
        }
        .tips-label{
          height: 16px;
          width: 28px;
          display: flex;
          justify-content: center;
          align-items: center;
          background-color: #4183FF;
          border-radius: 3px;
          margin-right: 3px;
          &>span{
            font-size: 20px;
            transform: scale(0.5);
            white-space: nowrap;   
          }
        }
      }
      .top{
        position: relative;
        .info{
          position: absolute;
          bottom: 0;
          color: #ffffff;
          display: flex;
          align-items: flex-end;
          font-size: 12px;
          height: 62px;
          width: 100%;
          background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.7) 100%);
          .hot, .jobs-count{
            display: flex;
            padding-bottom: 10px;
            padding-left: 12px;
            align-items: center;
            i{
              margin-right: 4px;
              font-size: 12px;
            }
          }
        }
      }
      .bottom{
        display: flex;
        padding: 12px 14px;
        img{
          width: 38px;
          height: 38px;
          margin: 0;
          border-radius: 4px;
          border: 1px solid #F4F4F4;
          margin-right: 8px;
        }
        .right{
          padding: 2px 0;
          .company-name{
            font-weight: 800;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            max-width: 150px;
          }
          .desc{
            color: #9c9c9c;
            margin-top: 7px;
            font-size: 13px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            max-width: 150px;
          }
        }
      }
    }

    img {
      border-radius: 6px;
      margin: auto;
      width: 226px;
      height: 120px;
    }

    p {
      // text-align: center;
      margin: 14px 16px;
    }
  }
</style>
